import { useForm } from "@inertiajs/react"
import { Button } from "./ui/button"
import { Input } from "./ui/input"
import { Label } from "./ui/label"
import { Mail } from "lucide-react"
import { useState } from "react"

interface NewsletterSubscriptionProps {
  title?: string
  description?: string
}

const NewsletterSubscription = ({
  title = "Subscribe to Our Newsletter",
  description = "Get notified about new blog posts, tutorials, and insights."
}: NewsletterSubscriptionProps) => {
  const { data, setData, post, processing, errors } = useForm({
    email: ""
  })

  const [successMessage, setSuccessMessage] = useState<string | null>(null)

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    post('/newsletter_subscriptions', {
      preserveState: true,
      preserveScroll: true,
      onSuccess: (page) => {
        setData("email", "") // Clear the input field
        const flash = page.props.flash as { notice?: string }
        setSuccessMessage(flash?.notice || null)
        setTimeout(() => setSuccessMessage(null), 10000)
      }
    })
  }

  return (
    <div className={`bg-muted/50 p-6 rounded-lg`}>
      <div className="text-center mb-6">
        <div className="flex justify-center mb-3">
          <div className="p-3 rounded-full bg-primary/10">
            <Mail className="h-6 w-6 text-primary" />
          </div>
        </div>
        <h3 className="text-xl font-semibold mb-2">{title}</h3>
        <p className="text-muted-foreground">{description}</p>
      </div>

      {successMessage && (
        <div className="mb-4 p-3 bg-green-50 border border-green-200 rounded-lg text-center">
          <p className="text-sm text-green-700">{successMessage}</p>
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <Label htmlFor="email">Email Address</Label>
          <Input
            id="email"
            name="email"
            type="email"
            value={data.email}
            onChange={(e) => setData("email", e.target.value)}
            required
            placeholder="your.email@example.com"
            className={errors.email ? "border-red-500" : ""}
          />
          {errors.email && <p className="text-sm text-red-500">{errors.email}</p>}
        </div>
        
        <Button type="submit" size="lg" disabled={processing} className="w-full">
          {processing ? "Subscribing..." : "Subscribe"}
        </Button>
      </form>
      
      <p className="text-xs text-muted-foreground mt-4 text-center">
        We respect your privacy. Unsubscribe at any time.
      </p>
    </div>
  )
}

export default NewsletterSubscription 